import type { FC, ReactNode } from 'react'

import { ChevronDown } from 'lucide-react'

const faqs = [
    {
        question: 'Do I have to manage all 21 agents?',
        answer: "No. You only talk to the Coordinator. It decides which specialists a request needs, splits the work between them and reports back to you in one place."
    },
    {
        question: 'What can the agents actually do?',
        answer: "They work in four teams. Marketing promotes your product, Lead Generation finds and qualifies prospects, Email Outreach writes and follows up, and Bug Fixing finds, fixes and tests problems in your product."
    },
    {
        question: 'Can several teams work at the same time?',
        answer: "Yes. The Coordinator runs the teams in parallel, so a launch campaign, a fresh list of prospects and a bug fix can all move forward at once."
    },
    {
        question: "How do I know what's happening?",
        answer: "Ask the Coordinator. It knows the status of every task and every agent, and gives you a plain summary whenever you want one."
    },
    {
        question: 'How do I get started?',
        answer: "Book a demo below. We will walk you through the Coordinator using your own product and show you the agents at work."
    }
]

const FaqSection: FC = (): ReactNode => {
    return (
        <section id='faq' className='py-24 sm:py-32'>
            <div className='mx-auto max-w-3xl px-5 sm:px-8'>
                <div className='text-center'>
                    <p className='font-mono text-xs uppercase tracking-[0.2em] text-primary'>
                        FAQ
                    </p>
                    <h2 className='mt-4 font-heading text-3xl font-semibold tracking-tight text-balance sm:text-5xl'>
                        Questions, answered
                    </h2>
                </div>

                <div className='mt-12 divide-y divide-white/10 rounded-2xl border border-white/10 bg-card/60'>
                    {faqs.map((faq) => (
                        <details key={faq.question} className='group px-5 sm:px-6'>
                            <summary className='flex cursor-pointer list-none items-center justify-between gap-4 py-5 font-medium [&::-webkit-details-marker]:hidden'>
                                {faq.question}
                                <ChevronDown className='size-5 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-180' aria-hidden='true' />
                            </summary>
                            <p className='pb-5 leading-relaxed text-muted-foreground'>
                                {faq.answer}
                            </p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FaqSection
